import { useStaticQuery, graphql } from 'gatsby';

export const useGlobal = () => {
	const { global } = useStaticQuery(graphql`
		query GlobalLinks {
			global: allDatoCmsGlobal {
				nodes {
					earlypaySignUpLink
					earlypayLoginLink
					cashflowFinanceLoginLink
					earlypayFxLoginLink
					timelioLink
				}
			}
		}
	`);

	return { global: global.nodes[0] };
};
